import { call, put, takeLatest } from "redux-saga/effects";
import { getSOWDetails } from "../http/requests/sow";
import { SOWType, setSOWData, setVtrackLoader } from "../redux/actions";

function* workerSOWSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    const response = yield call(
      getSOWDetails,
      payload.pageNo,
      payload.pageSize,
      payload.sortDir,
      payload.sortBy,
      payload.searchData,
      payload.clientId
    );
    // Normalize API response (backend may return PascalCase Data/TotalCount and item keys)
    const rawData = response?.data ?? response?.Data ?? [];
    const data = Array.isArray(rawData)
      ? rawData.map((item) => ({
          sowId: item?.sowId ?? item?.SOWId,
          sowName: item?.sowName ?? item?.SOWName,
          clientId: item?.clientId ?? item?.ClientId,
          sowStartDate: item?.sowStartDate ?? item?.SOWStartDate,
          sowEndDate: item?.sowEndDate ?? item?.SOWEndDate,
          sowType: item?.sowType ?? item?.SOWType,
          namedSOWFlag: item?.namedSOWFlag ?? item?.NamedSOWFlag,
          status: item?.status ?? item?.Status,
          deliveryManagerUserId: item?.deliveryManagerUserId ?? item?.DeliveryManagerUserId,
          accountManagerUserID: item?.accountManagerUserID ?? item?.AccountManagerUserID,
          note: item?.note ?? item?.Note,
          linkedProjectNames: item?.linkedProjectNames ?? item?.LinkedProjectNames,
          active: item?.active ?? item?.Active,
        }))
      : [];
    const sowDetails = {
      data,
      totalCount: response?.totalCount ?? response?.TotalCount ?? 0,
    };
    yield put(setSOWData(sowDetails));
    yield put(setVtrackLoader(false));
  } catch (err) {
    console.error("SOW fetch failed:", err?.data || err?.statusText || err);
    yield put(setSOWData({ data: [], totalCount: 0 }));
    yield put(setVtrackLoader(false));
  }
}

export function* sowSaga() {
  yield takeLatest(SOWType.GET_SOW_DATA, workerSOWSaga);
}
